export default __webpack_public_path__ + "static/media/device_yangek_off.8bced6c1.svg";